import { render, staticRenderFns } from "./CreateCustomItem.vue?vue&type=template&id=56dba6d5&scoped=true&"
import script from "./CreateCustomItem.vue?vue&type=script&lang=js&"
export * from "./CreateCustomItem.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomItem.vue?vue&type=style&index=0&id=56dba6d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dba6d5",
  null
  
)

export default component.exports